import apiClient from './client';

export interface AuthUser {
  id: string;
  email: string;
  full_name: string;
  role: 'analyst' | 'reviewer' | 'principal' | 'compliance' | 'operator';
  is_active: boolean;
  can_see_all_cases?: boolean;
  // derived server-side -- true when the user may train learned
  // rules (operator role OR per-user settings flag).
  can_train_rules?: boolean;
  // derived server-side -- true when the user may use the case
  // Chat tab (operator role OR per-user settings flag).
  can_chat_case?: boolean;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  user: AuthUser;
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  // Send both username + email so the backend can match by EITHER field
  // (User.username == body.username OR User.email == body.email). This lets
  // users type their username (e.g. "admin") OR email in the login field.
  const { data } = await apiClient.post<LoginResponse>('/auth/login', { username: email, email, password });
  return data;
}

export interface RefreshResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export async function refreshToken(
  refreshToken: string
): Promise<RefreshResponse> {
  const { data } = await apiClient.post<RefreshResponse>('/auth/refresh', {
    refresh_token: refreshToken,
  });
  return data;
}

export async function getCurrentUser(): Promise<AuthUser> {
  const { data } = await apiClient.get<AuthUser>('/auth/me');
  return data;
}